import React from 'react';
import DocumentTemplate from './DocumentTemplate';

/**
 * Invoice document — delegates to the unified DocumentTemplate.
 * Maintains backward compatibility with existing props: { data, docType }
 */
export default function InvoiceDocument({ data, docType = 'invoice' }) {
  return <DocumentTemplate docType="invoice" data={data} />;
}
